// extracted by mini-css-extract-plugin
export default {"mono":"mono--5ae0bc"};